import { z } from "zod";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const phoneNumberSchema = z.string().refine(
    (value) => parsePhoneNumberFromString(value)?.isValid(),
    { message: 'Invalid phone number. Please use international format (e.g., +1234567890)' }
);

export const phoneNumberArraySchema = z.array(phoneNumberSchema).transform((phones) => [...new Set(phones)]);

export type PhoneNumber = z.infer<typeof phoneNumberSchema>;
export type PhoneNumberArray = z.infer<typeof phoneNumberArraySchema>;
